export default "__VITE_ASSET__BzCh9001__"